import BasicCard from '../../../components/basicCard/BasicCard';
import { Image } from 'antd';

type NewsItemProps = {
  title: string;
  description: string;
  actionText: string;
  action?: Function;
  thumbUrl?: string;
};

const NewsItem = ({ title, description, actionText, action, thumbUrl }: NewsItemProps) => {
  return (
    <div className="news-item hover-raise h-full">
      <BasicCard radius="lg">
        <div className="news-item flex h-full min-h-[350px] flex-col gap-3 p-4">
          <div className="thumbnail overflow-hidden rounded border border-[#E0E7F5] p-0 [&_.ant-image]:w-full">
            <Image
              src={thumbUrl || '/images/checkers.png'}
              style={{ objectFit: 'cover' }}
              alt={title}
              className="m-0 h-full max-h-[150px] w-full"
            />
          </div>
          <div className="flex-1">
            <h3 className="title text-xl font-medium leading-7 -tracking-[0.8px] text-black">
              {title}
            </h3>
            <p className="description text-sm text-font-color">
              {description && description.length > 100
                ? description.slice(0, 100) + '...'
                : description}
            </p>
          </div>
          <button
            className="link text-start text-primary"
            onClick={() => (action ? action() : null)}
          >
            {actionText}
          </button>
        </div>
      </BasicCard>
    </div>
  );
};

export default NewsItem;
